@if (showLoader()) {
  <wl-loading-screen
    [title]="rendering() | scFieldValue: 'LoadingScreenTitle'"
    [subtitle]="address"
    [items]="loaderItems()"
    [duration]="loadingDuration"
    (finished)="showLoader.set(false)"
    wlAutomationId="homebattery-order-form-loading-screen"
  />
}

<wl-homebattery-order-form-ui
  [rendering]="rendering()"
  [form]="form()"
  [submitState]="submitState()"
  [trackStep]="trackToolConfig().forStep('form')"
  (formSubmit)="submit()"
></wl-homebattery-order-form-ui>
